<template>
    <router-view/>
</template>
<script>
export default {
    name:'system-layout'
}
</script>